/**
 * Created by r4zi4l on 22.01.2021
 */

const ComponentTimer = cc.Node.extend({
    ctor: function (countdown, fullValue, options) {
        this._super();
        this.createTimer(countdown, fullValue, options);
    },

    clear: function () {
        this.countdown.countDown.stop();
    },

    resetTimeLeft: function (timeLeft) {
        this.countdown.countDown.resetTimeLeft(timeLeft);
    },

    createTimer: function (model, fullValue, options) {
        options = options || {};

        if (this.countdown) {
            this.countdown.removeFromParent();
        }

        const styles = cleverapps.styles.ComponentTimer.timer;

        const countDownConfig = {
            font: cleverapps.styles.FONTS.COMPONENT_TIMER_TEXT,
            icon: {
                frame: bundles.small_timer_merge.frames.timer_png,
                json: bundles.small_timer.jsons.small_timer_json,
                animation: "animation"
            },
            showHours: options.showHours
        };

        if (options.withoutBar) {
            countDownConfig.font = cleverapps.styles.FONTS.COMPONENT_TIMER_NO_BAR_TEXT;
            countDownConfig.background = {
                frame: bundles.small_timer.frames.small_timer_bg_png,
                width: options.showHours ? styles.withoutBar.widthWithHours : styles.withoutBar.width,
                height: styles.withoutBar.height
            };
        } else {
            countDownConfig.bar = {
                type: options.barType || ScaledProgressBar.Types.blue_with_frames,
                width: styles.width,
                fullValue,
                reversed: options.reversed
            };
        }

        this.countdown = new cleverapps.CountDownView(model, countDownConfig);
        this.countdown.setAlignment(styles);
        this.addChild(this.countdown);
    },

    createAnimation: function () {
        if (cleverapps.config.name !== "mergecraft") {
            return;
        }

        const styles = cleverapps.styles.ComponentTimer.animation;

        const animation = new cleverapps.Spine(bundles.small_timer_merge.jsons.timer_json);
        animation.setAlignment(styles);
        animation.setAnimation(0, "animation", true);
        this.addChild(animation);
    },

    createFastCountdown: function (params) {
        let time = params.time;
        let count = params.duration / 50;
        const step = params.limit / count;
        let id;

        const countdown = {
            onSecond: function () {},
            onFinish: params.callback || function () {},
            getTimeLeft: function () {
                return time; 
            },
            stop: function () {
                cleverapps.timeouts.clearInterval(id);
            },
            remove: function () {
                cleverapps.timeouts.clearInterval(id);
            }
        };

        const interval = 50;

        id = cleverapps.timeouts.setInterval(() => {
            if (count <= 0) {
                clearInterval(id);
                countdown.onFinish();
                return;
            }
            time = Math.max(params.minimalValue || 0, time - step);
            count -= 1;
            countdown.onSecond(interval / 1000);
        }, interval);

        return countdown;
    },

    runFastCountdownAnimation: function (duration) {
        const seconds = duration / 1000;
        const pulses = Math.ceil(seconds);
        const pulseTime = seconds / pulses;

        this.countdown.runAction(new cc.Repeat(new cc.Sequence(
            new cc.ScaleTo(pulseTime / 2, this.countdown.scale * 1.15),
            new cc.ScaleTo(pulseTime / 2, this.countdown.scale)
        ), pulses));
    }
});

ComponentTimer.hasHours = function (timeInMs) {
    return Math.floor(timeInMs / (1000 * 60 * 60)) > 0;
};

const BaseWorkerTimer = ComponentTimer.extend({
    ctor: function (worker, countdown, options) {
        this.worker = worker;
        this._super(countdown, this.worker.getFullJobTime(), options);
        this.createAnimation();

        this.worker.onDestructor = this.createListener(this.clear.bind(this));
    }
});

const InstantComponentTimer = BaseWorkerTimer.extend({
    ctor: function (worker, options) {
        const countdown = this.createFastCountdown(options);
        this._super(worker, countdown, {
            withoutBar: true,
            showHours: false
        });
        this.runFastCountdownAnimation(options.duration);
    }
});

const WorkerComponentTimer = BaseWorkerTimer.extend({
    ctor: function (worker) {
        this.state = undefined;

        const timeLeft = worker.getTimeLeft();
        const showHours = ComponentTimer.hasHours(timeLeft);

        const countdown = new cleverapps.CountDown(timeLeft, {
            onTick: this.updateState.bind(this)
        });

        this._super(worker, countdown, {
            withoutBar: true,
            showHours
        });

        this.updateState();
    },

    calcState: function () {
        const SoftFeastMission = cleverapps.missionManager.findByType(Mission.TYPE_BOOSTTIME);

        let state = WorkerComponentTimer.STATE_DEFAULT;
        if (Unit.CalcSpeedUPPrice(this.worker.getTimeLeft()) === 0 || cleverapps.tutorial.checkConditions({ unit: this.worker.unit })) {
            state = WorkerComponentTimer.STATE_FREE;
        } else if (SoftFeastMission && SoftFeastMission.isRunning() && MissionManager.hasProperLocation(SoftFeastMission.type)) {
            state = WorkerComponentTimer.STATE_BONUS_COINS;
        } else if (this.worker.isSpeedUpBonusActive()) {
            if (this.worker.getTimeLeft() <= cleverapps.parseInterval(Workers.SPEEDUP_BONUS_TIME)) {
                state = WorkerComponentTimer.STATE_BONUS_WATCH_AD_COMPLETE;
            } else {
                state = WorkerComponentTimer.STATE_BONUS_WATCH_AD;
            }
        }

        return state;
    },

    updateState: function () {
        const state = this.calcState();

        if (state !== this.state) {
            this.state = state;
            this.hideButton();
            this.showButton();
        }
    },

    onButtonClick: function () {
        switch (this.state) {
            case WorkerComponentTimer.STATE_FREE:
                this.worker.speedUp();
                break;
            case WorkerComponentTimer.STATE_BONUS_COINS:
                cleverapps.focusManager.display({
                    focus: "FromTimerSpeedUp",
                    action: function (f) {
                        new SpeedUpWindow(this.worker);
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }.bind(this)
                });
                break;
            case WorkerComponentTimer.STATE_BONUS_WATCH_AD:
            case WorkerComponentTimer.STATE_BONUS_WATCH_AD_COMPLETE:
                this.worker.speedUpForVideo();
                break;
        }
    },

    showButton: function () {
        const styles = cleverapps.styles.WorkerComponentTimer;

        if (this.state === WorkerComponentTimer.STATE_DEFAULT) {
            return;
        }

        if (!this.buttonContainer) {
            this.buttonContainer = new cc.Node();
            this.buttonContainer.adviceTarget = Map2d.SPEED_UP;
            this.addChild(this.buttonContainer);
        }

        let text, textVariant;
        let spineButton = false;
        switch (this.state) {
            case WorkerComponentTimer.STATE_FREE:
                text = Messages.get("FREE");
                break;
            case WorkerComponentTimer.STATE_BONUS_COINS:
                text = TextWithIcon.ICONS_BY_NAME.speedup;
                spineButton = true;
                break;
            case WorkerComponentTimer.STATE_BONUS_WATCH_AD:
                text = `${TextWithIcon.ICONS_BY_NAME.ads}${Messages.get("ComponentTimer.boost")}`;
                textVariant = "tiny";
                break;
            case WorkerComponentTimer.STATE_BONUS_WATCH_AD_COMPLETE:
                text = `${TextWithIcon.ICONS_BY_NAME.ads}${Messages.get("ComponentTimer.complete")}`;
                textVariant = "tiny";
                break;
        }

        if (spineButton) {
            this.buttonContainer.setAlignment(styles.spineButton);
            this.button = new cleverapps.Spine(bundles.small_timer_merge.jsons.speedup_json);
            this.button.setAnimationAndIdleAfter("showup", "idle");
            cleverapps.UI.onClick(this.button, this.onButtonClick.bind(this));
        } else {
            this.buttonContainer.setAlignment(styles.button);
            this.button = new cleverapps.UI.Button({
                width: styles.button.width,
                height: styles.button.height,
                text,
                textVariant,
                onClicked: this.onButtonClick.bind(this),
                type: cleverapps.styles.UI.Button.Images.timer_button_blue
            });
        }

        this.buttonContainer.addChild(this.button);

        this.button.setScale(0.3);
        this.button.runAction(new cc.ScaleTo(0.2, 1));
    },

    hideButton: function () {
        if (this.button) {
            if (this.button instanceof cleverapps.Spine && this.button.hasAnimation("hide")) {
                this.button.setAnimation(0, "hide", false);
                this.button.setCompleteListenerRemove();
            } else {
                this.button.runAction(new cc.Sequence(
                    new cc.ScaleTo(0.2, 0.3),
                    new cc.RemoveSelf()
                ));
            }
            this.button = undefined;
        }
    },

    showBoost: function (params) {
        this.hideButton();
        params = { time: this.worker.getTimeLeft(), ...params };
        this.createTimer(this.createFastCountdown(params));
        this.runFastCountdownAnimation(params.duration);
    }
});

const LockedComponentTimer = ComponentTimer.extend({
    ctor: function (locked) {
        this.locked = locked;

        const timeLeft = locked.getTimeLeft();
        const showHours = ComponentTimer.hasHours(timeLeft);

        const countdown = new cleverapps.CountDown(timeLeft, {
            onTick: this.updateState.bind(this)
        });

        this._super(countdown, locked.harvestDuration, {
            withoutBar: true,
            showHours
        });
    },

    updateState: function () {
        if (Unit.CalcSpeedUPPrice(this.locked.getTimeLeft()) === 0 && !this.button) {
            this.showButton();
        }
    },

    showButton: function () {
        const styles = cleverapps.styles.WorkerComponentTimer.button;

        const button = this.button = new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            text: Messages.get("FREE"),
            onClicked: () => {
                this.locked.unlock();
            },
            type: cleverapps.styles.UI.Button.Images.timer_button_blue
        });

        button.setAlignment(styles);
        this.addChild(button);

        button.setScale(0.3);
        button.runAction(new cc.ScaleTo(0.2, 1));
    }
});

WorkerComponentTimer.STATE_DEFAULT = 0;
WorkerComponentTimer.STATE_FREE = 1;
WorkerComponentTimer.STATE_BONUS_COINS = 2;
WorkerComponentTimer.STATE_BONUS_WATCH_AD = 3;
WorkerComponentTimer.STATE_BONUS_WATCH_AD_COMPLETE = 4;

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    COMPONENT_TIMER_TEXT: {
        size: 20,
        color: cleverapps.styles.COLORS.WHITE
    },

    COMPONENT_TIMER_NO_BAR_TEXT: {
        name: "lightstroke",
        size: 28,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR
    }
});

cleverapps.styles.ComponentTimer = {
    timer: {
        width: 136,
        x: 0,
        y: 0,

        withoutBar: {
            width: 110,
            widthWithHours: 160,
            height: 32
        }
    },

    animation: {
        x: 0,
        y: 70
    }
};

cleverapps.styles.WorkerComponentTimer = {
    button: {
        x: 0,
        y: -45,
        width: 140,
        height: 50
    },

    spineButton: {
        x: -50,
        y: 90
    },

    bonus: {
        x: -43,
        y: 58
    }
};
